import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Palmtree, Plane, Building2, Car, Bus, ChevronDown, User, Menu, X } from 'lucide-react';
const hotelDestinations = [{
  name: 'Hotels in Dubai',
  href: '#dubai'
}, {
  name: 'Hotels in Kathmandu',
  href: '#kathmandu'
}, {
  name: 'Hotels in France',
  href: '#france'
}, {
  name: 'Hotels in Delhi',
  href: '#delhi'
}];
export function Header() {
  const [isHotelsOpen, setIsHotelsOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navItems = [{
    name: 'Holidays',
    icon: Palmtree,
    href: '#holidays'
  }, {
    name: 'Flights',
    icon: Plane,
    href: '#flights'
  }, {
    name: 'Hotels',
    icon: Building2,
    href: '#hotels',
    hasDropdown: true
  }, {
    name: 'Cars',
    icon: Car,
    href: '#cars'
  }, {
    name: 'Buses',
    icon: Bus,
    href: '#buses'
  }];
  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.hash = '';
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-92">
          {/* Logo */}
          <a href="#" onClick={handleLogoClick} className="flex items-center gap-2" data-id="element-93">
            <div className="w-10 h-10 bg-travel-blue-600 rounded-full flex items-center justify-center" data-id="element-94">
              <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-95">
                <circle cx="12" cy="12" r="10" data-id="element-96" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" data-id="element-97" />
                <path d="M2 12h20" data-id="element-98" />
              </svg>
            </div>
            <span className="text-xl font-bold text-travel-blue-600" data-id="element-99">
              Travel Sewa
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-100">
            {navItems.map(item => <div key={item.name} className="relative" onMouseEnter={() => item.hasDropdown && setIsHotelsOpen(true)} onMouseLeave={() => item.hasDropdown && setIsHotelsOpen(false)} data-id="element-101">
                <a href={item.href} className="flex flex-col items-center px-5 py-3 rounded-xl text-gray-600 hover:bg-travel-blue-50 hover:text-travel-blue-600 transition-colors" data-id="element-102">
                  <item.icon className="w-5 h-5 mb-1" data-id="element-103" />
                  <span className="text-sm font-medium flex items-center gap-1" data-id="element-104">
                    {item.name}
                    {item.hasDropdown && <ChevronDown className="w-3 h-3" data-id="element-105" />}
                  </span>
                </a>

                {/* Hotels Dropdown */}
                {item.hasDropdown && <AnimatePresence data-id="element-106">
                    {isHotelsOpen && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute top-full left-0 mt-1 w-56 bg-white rounded-xl shadow-xl border border-gray-100 py-2 overflow-hidden" data-id="element-107">
                        {hotelDestinations.map(dest => <a key={dest.name} href={dest.href} className="block px-4 py-3 text-gray-700 hover:bg-travel-blue-50 hover:text-travel-blue-600 transition-colors" data-id="element-108">
                            {dest.name}
                          </a>)}
                      </motion.div>}
                  </AnimatePresence>}
              </div>)}
          </nav>

          {/* Right Side Actions */}
          <div className="flex items-center gap-3" data-id="element-109">
            <a href="#list-property" className="hidden md:flex items-center gap-2 px-4 py-2 border-2 border-travel-blue-600 text-travel-blue-600 rounded-lg font-medium hover:bg-travel-blue-600 hover:text-white transition-colors" data-id="element-110">
              <Building2 className="w-4 h-4" data-id="element-111" />
              <span data-id="element-112">List Your Property</span>
            </a>

            <button className="p-2 rounded-full border border-gray-200 text-gray-600 hover:border-travel-blue-600 hover:text-travel-blue-600 transition-colors" aria-label="User account" data-id="element-113">
              <User className="w-5 h-5" data-id="element-114" />
            </button>

            {/* Mobile Menu Button */}
            <button className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-115">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-116" /> : <Menu className="w-6 h-6" data-id="element-117" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-118">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="lg:hidden border-t border-gray-100 overflow-hidden" data-id="element-119">
              <nav className="py-4 space-y-1" data-id="element-120">
                {navItems.map(item => <div key={item.name} data-id="element-121">
                    <a href={item.href} className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-travel-blue-50 hover:text-travel-blue-600 rounded-lg transition-colors" data-id="element-122">
                      <item.icon className="w-5 h-5" data-id="element-123" />
                      <span className="font-medium" data-id="element-124">{item.name}</span>
                    </a>
                    {item.hasDropdown && <div className="ml-12 mt-1 space-y-1" data-id="element-125">
                        {hotelDestinations.map(dest => <a key={dest.name} href={dest.href} className="block px-4 py-2 text-sm text-gray-600 hover:text-travel-blue-600" data-id="element-126">
                            {dest.name}
                          </a>)}
                      </div>}
                  </div>)}
                <a href="#list-property" className="flex items-center gap-3 px-4 py-3 text-travel-blue-600 font-medium" data-id="element-127">
                  <Building2 className="w-5 h-5" data-id="element-128" />
                  <span data-id="element-129">List Your Property</span>
                </a>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}